import { render, staticRenderFns } from "./SlidingList.vue?vue&type=template&id=420e3046&"
import script from "./SlidingList.vue?vue&type=script&lang=js&"
export * from "./SlidingList.vue?vue&type=script&lang=js&"
import style0 from "./SlidingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports